<!--
 * @Author: your name
 * @Date: 2021-09-03 09:58:52
 * @LastEditTime: 2021-09-28 11:23:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/courseIntroduction.vue
-->
<!--  -->
<template>
  <div
    class="introduce"
    v-html="introduction"
  ></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    introduction: {
      type: String,
      default: '',
    },
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
.introduce {
  width: 100%;
  padding: 36px;
  ::v-deep img {
    width: 100%;
    // margin-top: 10px;
  }
  ::v-deep p {
    padding-top: 10px;
    font-size: 36px;
    &:nth-of-type(1) {
      padding-top: 0;
    }
  }
}
</style>
